import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/components/AfterResultBot.css";
import omnicareLogo from "../../assets/icons/logo.svg";
import doctorImage from "../../assets/images/doctor.png";
import backIcon from "../../assets/icons/back.svg";
import LanguageSwitcher from "../LanguageSwitcher";

const AfterQuiz4 = () => {
  const navigate = useNavigate();

  const handleShowComparison = () => {
    navigate("/after-quiz/5");
  };

  const handleSelfBooking = () => {
    navigate("/thankyou?from=after-quiz-4");
  };

  const handleBack = () => {
    navigate("/after-quiz/3");
  };

  return (
    <div className="after-result-bot-container">
      {/* Header */}
      <header className="after-result-bot-header">
        <div className="logo-section">
          <div className="logo" onClick={() => navigate("/landing")} style={{ cursor: 'pointer' }}>
            <img src={omnicareLogo} alt="Pebble Health Logo" className="logo-icon" />
            <span className="logo-text">Pebble Health</span>
          </div>
        </div>
        <div className="header-actions">
          <LanguageSwitcher />
          <div className="back-button" onClick={handleBack}>
            <img src={backIcon} alt="Back" className="back-icon" />
          </div>
        </div>
      </header>

      {/* Doctor illustration above divider */}
      <div className="doctor-divider">
        <img src={doctorImage} alt="Dr. Sam" className="doctor-avatar" />
      </div>

      <div className="after-result-bot3-content">
        <h2 className="congrats-text">
          Services like <a href="https://www.teladoc.com/" className="info-link" target="_blank" rel="noopener noreferrer">Teladoc Health</a>, <a href="https://sesamecare.com/" className="info-link" target="_blank" rel="noopener noreferrer">Sesame Care</a>, and <a href="https://carbonhealth.com/" className="info-link" target="_blank" rel="noopener noreferrer">Carbon Health</a> let you meet with doctors online and easily get referrals.
          <br />
          These can usually be done within 20 minutes.
        </h2>
      </div>

      <div className="after-result-bot3-buttons after-result-bot4-buttons">
        <button type="button" className="answer-block answer-consult" onClick={handleShowComparison}>
          <div className="answer-title">Help me choose the best one</div>
        </button>
        <button type="button" className="answer-block answer-free" onClick={handleSelfBooking}>
          <div className="answer-title">I'll make the booking myself</div>
        </button>
      </div>
    </div>
  );
};

export default AfterQuiz4;
